import { TEXT_AREA_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { StringValue } from '../../../value/types';
import type { SUPPORTED_RICH_TEXT_TYPES } from '../types';

const getStringValue: StringValue<{
	fieldId: string;
	type: SUPPORTED_RICH_TEXT_TYPES;
	value: string | null;
}> = (field) => String(field.value || '');

export const richTextStringValueHandler = {
	[TEXT_AREA_CF_TYPE]: getStringValue,
};
